import { useQuery } from 'react-query';
import format from 'date-fns/format';
import { CustomerPhotographerBookingApi } from '../../../../photographerBooking/se360/v2/shared/queries/CustomerPhotographerBookingApi';
import {
    BookingAddress,
    CustomerBookingResult
} from '../../../../photographerBooking/se360/v2/shared/types';

type PhotographerSearch = {
    address: BookingAddress;
    productIds: number[];
    brokerFirmId: number | null;
    bookingDate: Date;
    enabled: boolean;
};

export function useAvailablePhotographersQuery({
    address,
    productIds,
    brokerFirmId,
    bookingDate,
    enabled
}: PhotographerSearch) {
    return useQuery<CustomerBookingResult>(
        [
            'create-order-available-photographers',
            address.street,
            address.zip,
            address.city,
            productIds.join(','),
            brokerFirmId,
            format(bookingDate, 'yyyy-MM-dd')
        ],
        () =>
            CustomerPhotographerBookingApi.getPhotographersForNewCustomerBooking(
                address,
                productIds.join(','),
                brokerFirmId as number,
                bookingDate
            ),
        { enabled: enabled && brokerFirmId !== null, cacheTime: 0, refetchOnWindowFocus: false }
    );
}
